module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "example-modal-content"
  }, [_c('h1', [_vm._v("This is a custom component")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.text))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2fda77a1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/CustomComponentModal.vue
// module id = 32
// module chunks = 0